import React from 'react';
import { BlogPostInfoRes } from 'react-query/blogApi';
import styled from 'styled-components';
import PostContentArea from './PostContentArea';
import PostMetaDataArea from './PostMetaDataArea';

interface Props {
  post: BlogPostInfoRes;
}

const PostContent = ({ post }: Props) => {
  const postTitle = post.title
    .replaceAll('&#8216;', '‘')
    .replaceAll('&#8217;', '’');

  return (
    <PostContentContainer>
      <div className="post-inner-container">
        {/* 카테고리, 제목, 날짜, 작성자, 포스트 타입 */}
        <PostMetaDataArea
          category={post.category}
          // title={post.title}
          title={postTitle}
          author={post.author}
          publishedDate={post.date}
          postType={post.post_type}
        />

        {/* 컨텐츠 영역 + 공유하기 + 태그 + 목록으로 */}
        <PostContentArea
          // title={post.title}
          title={postTitle}
          postId={post.id} // string
          content={post.content}
          tags={post.tags}
          postType={post.post_type}
        />
      </div>
    </PostContentContainer>
  );
};

export default PostContent;

const PostContentContainer = styled.main`
  display: flex;
  align-items: center;
  justify-content: center;
  .post-inner-container {
    @media screen and (min-width: 1440px) {
      width: 100%;
      max-width: 1200px;
      margin: 128px auto;
    }
    @media screen and (min-width: 1240px) and (max-width: 1439px) {
      width: calc(100% - 192px);
      margin: 96px;
    }
    @media screen and (min-width: 905px) and (max-width: 1239px) {
      width: calc(100% - 112px);
      margin: 56px;
    }
    @media screen and (min-width: 600px) and (max-width: 904px) {
      width: calc(100% - 64px);
      margin: 32px;
    }
    @media screen and (max-width: 599px) {
      width: calc(100% - 32px);
      margin: 32px 16px;
    }
  }
`;
